import React from "react";

const VotePackageCard = ({
  package: pkg,
  onSelect,
  disabled = false,
  isLoading = false,
}) => {
  const isPremium = pkg.type === "weekly";
  const displayValue =
    pkg.type === "daily"
      ? `${(pkg.votes || 0).toLocaleString()} votes`
      : `${(pkg.votesPerDay || 0).toLocaleString()} votes/day`;

  return (
    <div
      className={`relative overflow-hidden rounded-xl border transition-all duration-200 ${
        isPremium
          ? "border-accent-dim bg-surface-850 hover:border-accent hover:bg-surface-800"
          : "border-line bg-surface-850 hover:border-line-strong hover:bg-surface-800"
      } ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
      onClick={() => !disabled && !isLoading && onSelect(pkg)}
    >
      {/* Badge */}
      <div
        className={`absolute top-0 right-0 px-3 py-1.5 text-xs font-semibold uppercase tracking-wider text-white ${
          isPremium ? "bg-accent" : "bg-surface-600"
        }`}
      >
        {isPremium ? "Weekly" : "Daily"}
      </div>

      {/* Content */}
      <div className="p-6">
        {/* Package Name */}
        <h3 className="text-xl font-bold text-white mb-2 pr-16">{pkg.name}</h3>

        {/* Price */}
        <div className="mb-5 flex items-baseline">
          <span className="text-3xl font-bold tracking-tight text-white">
            ZMW {pkg.price.toLocaleString()}
          </span>
          <span className="text-gray-500 ml-2 text-sm">
            {pkg.type === "daily" ? "/ day" : "/ week"}
          </span>
        </div>

        {/* Vote Value */}
        <div className="mb-5 p-3 bg-surface-900 rounded-lg border border-line">
          <p className="text-gray-500 text-xs uppercase tracking-wider mb-0.5">
            You get
          </p>
          <p className="text-lg font-semibold text-accent-soft">{displayValue}</p>
        </div>

        {/* Duration info for weekly */}
        {pkg.type === "weekly" && (
          <div className="mb-5 text-sm text-gray-500">
            <p>Duration: {pkg.durationDays} days</p>
            <p className="text-xs mt-1">
              Total: ~{(pkg.votesPerDay * pkg.durationDays).toLocaleString()} votes
            </p>
          </div>
        )}

        {/* Features List */}
        <ul className="space-y-2.5 mb-6 text-gray-400 text-sm">
          <li className="flex items-center">
            <svg
              className="w-4 h-4 mr-2.5 text-accent flex-shrink-0"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            {pkg.type === "daily" ? "Valid for 24 hours" : "Valid for 7 days"}
          </li>
          <li className="flex items-center">
            <svg
              className="w-4 h-4 mr-2.5 text-accent flex-shrink-0"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            Use on any voting contest
          </li>
          <li className="flex items-center">
            <svg
              className="w-4 h-4 mr-2.5 text-accent flex-shrink-0"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            Instant delivery
          </li>
        </ul>

        {/* CTA Button */}
        <button
          onClick={() => !disabled && !isLoading && onSelect(pkg)}
          disabled={disabled || isLoading}
          className={`w-full py-3 px-4 rounded-lg font-semibold transition-colors duration-150 ${
            isPremium
              ? "bg-accent hover:bg-accent-hover text-white"
              : "bg-surface-600 hover:bg-surface-700 text-white border border-line-strong"
          } ${disabled ? "opacity-50 cursor-not-allowed" : ""} ${
            isLoading ? "opacity-75 cursor-wait" : ""
          }`}
        >
          {isLoading ? "Processing..." : "Buy Now"}
        </button>
      </div>
    </div>
  );
};

export default VotePackageCard;
